import { HTTPStatusCode, SortOrder } from '@ardoq/api-types';
import { Result } from '@ardoq/common-helpers';

interface FetchErrorContext {
  response: Response;
  json?: {
    message?: string;
    traceId?: string;
    data?: unknown;
  };
}
export class FetchError extends Error {
  constructor(
    message: string,
    public context: FetchErrorContext
  ) {
    super(message);
    this.name = 'FetchError';
  }
  getStatus(): HTTPStatusCode {
    return this.context.response.status;
  }
  getTraceId(): string {
    return this.context.json?.traceId ?? '';
  }

  getMessage(): string {
    return this.context.json?.message ?? this.message;
  }

  getData(): unknown {
    return this.context.json?.data;
  }
}
export type SearchParams = {
  size?: number;
  from?: number;
  sortOrder?: SortOrder;
  sortBy?: string;
  branchId?: string | null;
};

export type ApiResponse<T> = Promise<Result<T>>;
